import RecommendationsIconFactory from '../icons/factory-builder';

export default RecommendationsIconFactory;
